import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const api = {
  siteContent: () => client.get("/site-content").then((r) => r.data),
  page: (slug) => client.get(`/pages/${slug}`).then((r) => r.data),
  committees: () => client.get("/committees").then((r) => r.data),
  grDownload: (id) => client.get(`/grs/${id}/download`).then((r) => r.data),
  trackVisit: () => client.post("/track-visit").then((r) => r.data),
  importantNotice: () => client.get("/important-notice").then((r) => r.data),
  footerSettings: () => client.get("/footer-settings").then((r) => r.data),
  stats: () => client.get("/stats").then((r) => r.data),
  counters: () => client.get("/counters").then((r) => r.data),
  officeBearers: () => client.get("/office-bearers").then((r) => r.data),
  districts: () => client.get("/districts").then((r) => r.data),
  district: (slug) => client.get(`/districts/${slug}`).then((r) => r.data),
  grs: (params) => client.get("/grs", { params }).then((r) => r.data),
  upcoming: () => client.get("/upcoming").then((r) => r.data),
  gapl: () => client.get("/gapl").then((r) => r.data),
  ads: (slot) => client.get("/ads", { params: slot ? { slot } : {} }).then((r) => r.data),
  sponsors: () => client.get("/sponsors").then((r) => r.data),
  gaplSponsors: () => client.get("/gapl-sponsors").then((r) => r.data),
  adRateCard: () => client.get("/ad-rate-card").then((r) => r.data),
  slideshow: () => client.get("/slideshow").then((r) => r.data),
  socialSettings: () => client.get("/social-settings").then((r) => r.data),
  createIssue: (payload) => client.post("/issues", payload).then((r) => r.data),
};
